<script setup lang="ts">
import { useEntityStore } from '@/data/useEntityStore'
import { useCaseNavigationContext } from '@/modules/Cases/Sidebar/caseSidebarNavigationContext'
import { useProjects } from '@/modules/Projects/useProjects'
import CrumbItem from '@/modules/Workspaces/Crumbs/CrumbItem.vue'
import EntityCrumbComponent from '@/modules/Workspaces/Crumbs/EntityCrumb.vue'
import { nonNullable } from '@/shared/utils/typeAssertions'
import CrumbChevron from '@/sharedComponents/CrumbChevron.vue'
import SidebarJumpToProperty from '@/sharedComponents/SidebarJumpToProperty.vue'
import { computed } from 'vue'
import { useAllStageFields } from './useAllStageFields'

const projectStore = useProjects()
const entityStore = useEntityStore()

const { caseCrumbs, navigate, reset } = useCaseNavigationContext({ required: true })

const { fields } = useAllStageFields()

const properties = computed(() => fields.value.map((f) => f.property))

const projectCrumbLabel = computed(() => {
  const projectItem = caseCrumbs.value.find((b) => b.type === 'project')
  if (!projectItem) return undefined

  return (
    projectStore.projects.find((p) => p.id === projectItem.params.projectId)?.name ||
    projectItem.params.projectId
  )
})
</script>

<template>
  <template
    v-for="(crumb, idx) in caseCrumbs"
    :key="idx"
  >
    <!-- All data breadcrumb -->
    <CrumbItem
      v-if="crumb.type === 'root'"
      :active="crumb.isActive"
      @click="reset()"
    >
      All data
    </CrumbItem>

    <!-- File preview breadcrumb -->
    <template v-if="crumb.type === 'file'">
      <CrumbChevron />
      <CrumbItem :active="crumb.isActive">
        {{ crumb.file.name }}
      </CrumbItem>
    </template>

    <template v-if="crumb.type === 'project' && crumb.params.projectId && !crumb.params.entityId">
      <CrumbChevron />
      <CrumbItem
        :active="crumb.isActive"
        @click="navigate({ projectId: crumb.params.projectId })"
      >
        {{ projectCrumbLabel }}
      </CrumbItem>
    </template>
    <template v-if="crumb.type === 'project' && crumb.params.entityId">
      <CrumbChevron />
      <EntityCrumbComponent
        :active="crumb.isActive"
        :entity="nonNullable(entityStore.getFullOrPartialEntity(crumb.params.entityId))"
        @click="navigate({ projectId: crumb.params.projectId, entityId: crumb.params.entityId })"
      />

      <CrumbChevron v-if="properties.length > 0" />
      <SidebarJumpToProperty
        v-if="properties.length > 0"
        :properties="properties"
      />
    </template>
  </template>
</template>
